// The one upload limit that varies by deployment. It reads the build's
// environment, which is app wiring, so it stays here while the pure limits
// live in `@heidi/utils`.

/**
 * Max pages allowed for non-fillable PDF uploads.
 * Staging is 100 so long forms can be exercised; everywhere else (including
 * unset/unknown env) stays at 30. Keep in sync with
 * ml-scribe/shared/pymupdf/constants.py MAX_PAGES_FOR_LLM_FIELD_DETECTION.
 * Used in: form-filling-upload.tsx
 */
export const PDF_NON_FILLABLE_MAX_PAGES =
  process.env.NEXT_PUBLIC_ENVIRONMENT === 'staging' ? 100 : 30;
